import { ref } from 'vue';
import L from 'leaflet';

export const tooltip = ref({ visible: false, x: 0, y: 0, info: "" });

export const detectPolygonsUnderMouse = (event, target, polygonLayer) => {
  if (!target) return;
  const latlng = event.latlng;
  let foundPolygons = '[영역]\n';

  polygonLayer.value.forEach((layer) => {
    if (layer instanceof L.Circle) {
      const distance = target.distance(layer.getLatLng(), latlng);
      if (distance <= layer.getRadius()) {
        foundPolygons += (layer.options.name + '\n');
      }
    }
    else if (layer instanceof L.Polygon && layer.getBounds().contains(latlng) && isPointInPolygon(latlng, layer.getLatLngs())) {
      foundPolygons += (layer.options.name + '\n');
    }
  });

  if (foundPolygons.length > 0) {
    tooltip.value = {
      visible: true,
      x: event.originalEvent.pageX + 10,
      y: event.originalEvent.pageY + 10,
      info: foundPolygons,
    };
  } else {
    hideTooltip();
  }
};

export const detectMarkerUnderMouse = (event, devices) => {
  let foundMarkers = '[장치]\n';

  devices.forEach((device) => {
    foundMarkers += (device.device_name + '\n');
  });

  if (foundMarkers.length > 0) {
    tooltip.value = {
      visible: true,
      x: event.originalEvent.pageX + 10,
      y: event.originalEvent.pageY + 10,
      info: foundMarkers,
    };
  } else {
    hideTooltip();
  }
};

export const detectCustomMarkerUnderMouse = (event, info) => {
  if (info) {
    tooltip.value = {
      visible: true,
      x: event.originalEvent.pageX + 10,
      y: event.originalEvent.pageY + 10,
      info: info,
    };
  } else {
    hideTooltip();
  }
};

export const hideTooltip = () => {
  tooltip.value.visible = false;
};
// 점이 다각형 내부에 있는지 체크하는 함수
function isPointInPolygon(point, latlngs) {
  // Ray-casting 알고리즘
  let inside = false;
  latlngs = latlngs[0];
  const len = latlngs.length;
  const x = point.lng;
  const y = point.lat;

  // 다각형의 꼭지점들을 순차적으로 검사
  for (let i = 0, j = len - 1; i < len; j = i++) {
    const xi = latlngs[i].lng, yi = latlngs[i].lat;
    const xj = latlngs[j].lng, yj = latlngs[j].lat;

    const intersect = ((yi > y) !== (yj > y)) &&
                      (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }

  return inside;
}